<template>
    <Modal v-model:visible="visible" :backdrop="true">
        <template v-slot:header>
            <div>
                <h2 v-show="row_model?.id" class="text-lg font-bold">Modifiva riga di pianificazione sulla versione
                    {{ row_model.versione }}</h2>
                <h2 v-show="!row_model?.id" class="text-lg font-bold">Aggiungi riga di pianificazione sulla versione
                    {{ $attrs.versione.version }}</h2>
            </div>
        </template>
        <template v-slot:main>
            <div class="flex-grow pt-5 grid grid-cols-3 gap-3">
                <div class="flex flex-col mb-3 col-span-3">
                    <Field field_name="Cliente" :required="!clienteAutocomplete?.selection"
                           :errors="getErrors('cliente_id')"
                           placeholder="Cliente">
                        <VueMultiselect @search-change="clienteAutocomplete.search"
                                        :loading="clienteAutocomplete.isLoading"
                                        :options="clienteAutocomplete.options"
                                        v-model="clienteAutocomplete.selection"
                                        track-by="id" label="denominazione"
                                        class="next-vue-multiselect-single"
                                        placeholder="Cliente"
                                        deselectLabel="Deseleziona"
                                        selectedLabel="Selezionato"
                                        selectLabel="Seleziona">
                            <template v-slot:noResult>Nessun elemento trovato.</template>
                            <template v-slot:singleLabel="{option}">
                                {{ `${option.denominazione} - ${option.ragione_sociale}` }}
                            </template>
                            <template v-slot:option="{option}">{{
                                    `${option.denominazione} - ${option.ragione_sociale}`
                                }}
                            </template>
                        </VueMultiselect>
                    </Field>
                </div>
                <div class="flex flex-col mb-3 col-span-3">
                    <Field field_name="Descrizione" :required="!descrizione" v-model="descrizione" type="text"
                           :errors="getErrors('descrizione')"></Field>
                </div>
                <div class="col-span-3 grid grid-cols-4 gap-3">
                    <RigaIvaPianoFatturazione
                        v-for="(c, i) in righe_iva_model"
                        :key="i"
                        :iva=c.iva
                        v-model:valore=c.valore
                        :totaliIva=contatoriIva?.[c.iva.id]
                        :errors="errors"
                        :chiveForm="`righe.${i}.`"
                    >

                    </RigaIvaPianoFatturazione>
                </div>

                <div class="flex flex-col mb-3">
                    <Field field_name="Data emissione fattura" :required="!data_emissione_fattura"
                           v-model="data_emissione_fattura"
                           type="date"
                           :errors="getErrors('data_emissione_fattura')"></Field>
                </div>
                <div class="flex flex-col mb-3">
                    <Field field_name="Termini di pagamento" :required="!terminiDiPagamentoAutocomplete.selection"
                           :errors="getErrors('termine_pagamento_id')">

                        <VueMultiselect
                            v-model="terminiDiPagamentoAutocomplete.selection"
                            :options="terminiDiPagamentoAutocomplete.options"
                            @search-change="terminiDiPagamentoAutocomplete.search"
                            :loading="terminiDiPagamentoAutocomplete.isLoading"
                            placeholder="Scegli termine di pagamento"
                            class="next-vue-multiselect-single"
                            track-by="id"
                            label="descrizione"
                            selectLabel=""
                            deselectLabel=""
                            selectedLabel=""
                            :internal-search="true"
                        >
                        </VueMultiselect>
                    </Field>
                </div>

                <div class="flex flex-col mb-3">
                    <Field field_name="PO" :required="false" v-model="po"
                           :errors="getErrors('po')"></Field>
                </div>
                <div class="flex flex-col mb-3">
                    <Field field_name="Bef" :required="false" v-model="bef"
                           :errors="getErrors('bef')"></Field>
                </div>
                <div class="flex flex-col mb-3 col-span-2">
                    <Field field_name="Note" :required="false" v-model="note"
                           :errors="getErrors('note')">
                    </Field>
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <div class="flex justify-end pt-3">
                <NextButton variant="outline-secondary"
                            @click="$emit('update:visible', false)"
                            class="col-start-3 py-2 px-4">
                    Chiudi
                </NextButton>
                <NextButton variant="primary"
                            @click="save"
                            class="ml-4 py-2 px-4">
                    {{ row_model?.id ? 'Modifica' : 'Aggiungi' }}
                </NextButton>
            </div>
        </template>
    </Modal>
</template>

<script lang="ts">
import {Options, setup, Vue} from 'vue-class-component';
import Modal from "@/components/Modal.vue";
import NextButton from "@/components/NextButton.vue";
import NextEditor from "@/components/NextEditor.vue";
import Field from "@/components/Field.vue";
import Autocomplete from "@/setup/Autocomplete";
import clientiManager from "../api/Clienti";
import {Watch} from 'vue-property-decorator/lib/decorators/Watch';
import Select from "@/components/Select.vue";
import sottoprogettoPianoDiFatturazioneManager from "../api/SottoprogettoPianoDiFatturazione";
import sottoProgettiManager from "../api/SottoProgetti";
import {PianoFatturazioneStato} from "@/types";
import terminiPagamentoManager from "../api/TerminiPagamento";
import pivaManager from "../api/Piva";
import aliquotaManager from "../api/AliquotaManager";
import {mapActions, mapGetters, mapState} from "vuex";
import RigaIvaPianoFatturazione from "@/components/RigaIvaPianoFatturazione.vue";

@Options({
    name: 'ModalPianoFatturazione',
    components: {
        RigaIvaPianoFatturazione,
        Select,
        Field,
        NextEditor,
        Modal,
        NextButton
    },
    props: {
        visible: {
            type: Boolean,
            default: true
        },
        sottoprogetto_id: {
            type: [String, Number],
            required: true
        },
        row_model: Object,
        errors: {
            type: Object,
            required: false
        },
        contatoriIva: Object
    },
    computed: {
        ...mapGetters('sprjDataManager', [
            "AliquoteVenditaArray",
        ])
    }
})
export default class ModalPianoFatturazione extends Vue {
    visible!: boolean
    AliquoteVenditaArray!: any
    sottoprogetto_id!: any
    cliente_id!: any
    errors!: any[]
    righe_iva_model!: any[]

    descrizione!: string
    data_emissione_fattura!: string
    po!: string
    bef!: string
    note!: string

    clienteAutocomplete: any = setup(() => Autocomplete(clientiManager))
    terminiDiPagamentoAutocomplete: any = setup(() => Autocomplete(terminiPagamentoManager))

    created() {
        this.terminiDiPagamentoAutocomplete.search('', 0)
    }

    @Watch('row_model.descrizione')
    change_descrizione(new_value: any, old: any) {
        this.descrizione = new_value
    }

    @Watch('row_model.data_emissione_fattura')
    change_data_emissione_fattura(new_value: any, old: any) {
        this.data_emissione_fattura = new_value
    }

    @Watch('row_model.po')
    change_po(new_value: any, old: any) {
        this.po = new_value
    }

    @Watch('row_model.bef')
    change_bef(new_value: any, old: any) {
        this.bef = new_value
    }

    @Watch('row_model.note')
    change_note(new_value: any, old: any) {
        this.note = new_value
    }

    @Watch('row_model.cliente_id')
    cliente(new_value: any, old: any) {
        if (new_value) {
            this.clienteAutocomplete.retrieve(new_value)
        }
    }

    @Watch('row_model.termine_pagamento_id')
    termine_pagamento(new_value: any, old: any) {
        if (new_value) {
            this.terminiDiPagamentoAutocomplete.retrieve(new_value)
        }
    }

    @Watch('row_model.righe')
    righe(new_value: any, old: any) {
        // prendo prima tutte le ive che sono state settate nel sottoprogetto e le unisco a quelle del modello rimuovendo i duplicati
        const righe_iva_sottoprogetto = this.AliquoteVenditaArray;
        const righe_iva_piano_di_fatturazione = new_value.map((el: any) => {
            return el.iva
        });
        const all = righe_iva_sottoprogetto.concat(righe_iva_piano_di_fatturazione)
        const unique = {}
        const ret = []
        for (let i = 0; i < all.length; i++) {
            const dizionario = all[i];
            const id = dizionario.id;

            //@ts-ignore
            if (!unique[id]) {
                // Se non è stata vista, aggiungere il dizionario all'array risultato
                ret.push(dizionario);
                //@ts-ignore
                unique[id] = true;
            }
        }
        this.righe_iva_model = ret.map((el: any) => {
            const existing = new_value.find((nv: any) => {
                return nv.iva.id == el.id
            })
            return existing || {iva: el, valore: 0}
        });
    }

    getErrors(field: string) {
        return (this.errors as any)[field]
    }

    save() {
        this.$emit('save', {
            descrizione: this.descrizione,
            cliente_id: this.clienteAutocomplete.selection.id,
            data_emissione_fattura: this.data_emissione_fattura,
            termine_pagamento_id: this.terminiDiPagamentoAutocomplete.selection.id,
            po: this.po,
            bef: this.bef,
            note: this.note,

            righe: this.righe_iva_model.map((iva: any) => {
                return {iva_id: iva.iva.id, valore: iva.valore}
            })
        })
    }


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
